import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import { ChildrenPropType } from '../../services/proptypes';
var propTypes = {
  children: ChildrenPropType.isRequired
};

var Toggleable = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Toggleable, _React$Component);

  function Toggleable() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.state = {
      toggle: false
    };
    return _this;
  }

  var _proto = Toggleable.prototype;

  _proto.onToggle = function onToggle() {
    this.setState(function (_ref) {
      var toggle = _ref.toggle;
      return {
        toggle: !toggle
      };
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var toggle = this.state.toggle;
    var children = this.props.children;
    return children(toggle, function () {
      return _this2.onToggle();
    });
  };

  return Toggleable;
}(React.Component);

export { Toggleable as default };
Toggleable.propTypes = propTypes;